// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import TinymceController from "./tinymce_controller.js"
application.register("tinymce", TinymceController)

import GlobalController from "./global_controller.js"
application.register("global", GlobalController)

import GmapController from "./gmap_controller.js"
application.register("gmap", GmapController)